import { notification } from 'antd';
import { Action, Thunk, thunk, action } from 'easy-peasy';
import { assignForthSubject, classWiseFailedExamUrl, classWiseMeritExamUrl, createExamGradeUrl, deleteResultPublishDate, downloadtabulationExcel, examConfigurationUpdate, examCreate, examDeleteUrl, examForthSubjectChooseableList, examForthSubjectConfigurationList, examListForAdmitCardInstructionSaveUrl, examListForAdmitCardInstructionUrl, examMarkinputDataDeleteUrl, examMarkinputDataSaveUrl, examShortCodeDeleteUrl, examUpdate, fetchAdmitCardDownloadUrl, fetchAssignForthSubjectList, fetchClassWiseMeritByAcademicYearClassConfigIdExamConfigId, fetchelectiveSubjectConfigurationListByClassConfigurationIdAndGroupId, fetchExam, fetchExamByClassList, fetchExamByClassListUrl, fetchExamConfiguration, fetchExamConfigurationListUrl, fetchExamListByStudentClassUrl, fetchExamMarkInputStudentListClassConfigExamConfigIdGroupIdSubjectId, fetchExamMarkInputStudentListClassConfigExamConfigIdGroupIdSubjectIdUpdateUrl, fetchExamShortcodeByClassListUrl, fetchGrade, fetchGroupListByStudentClassUrl, fetchGroupListUrl, fetchMarkConfigListbySubjectIdUrl, fetchMarkConfigListUrl, fetchMarkSheetTemplateSaveUrl, fetchMarkSheetTemplateUrl, fetchresultPublishDateList, fetchSeatPLanDownloadUrl, fetchsectionMerit, fetchSemesterListByClassConfigIdRemarks, fetchSemesterListByClassConfigIdSectionWiseResult, fetchSemesterListByClassConfigIdUrl, fetchShortCode, fetchShortCodeClassListUrl, fetchStudentListByExamConfigIdAndClassConfigIdUrl, fetchSubject, fetchSubjectListByGroupID, fetchSubjectListByGroupIdNadClassIdListUrl, fetchSubjectListByGroupUrl, fetchSubjectMarkListBySectionWiseResult, fetchtabulationData, forthSubjectDelete, generalMarkSheetDownloadUrl, grandFinalMarkConfig, grandFinalMarkSheetDownloadUrl, markBlankSheeturl, markConfigurationSave, processExamMaritPositionUrl, processExamResultGenerateUrl, processExamResultGrandFinalUrl, remarksLisDeleteUrl, remarksListUrl, remarksLisUpdatetUrl, remarksSaveUrl, remarkTemplateList, saveRemarksUrl, saveResultPublishDate, sectionWiseFailedExamUrl, sectionWiseGradingSummaryUrl, sectionWisePassFailSummaryUrl, sectionWiseUnassignedMark, shortCodeCreate, shortCodeUpdate, subjectConfigurationCreate, subjectConfigurationDelete, subjectConfigurationUpdate, subjectCreate, subjectDeleteUrl, subjectUpdate, tabulationSheetUrl, updateExamGradeUrl, updateResultPublishDate } from '../../../http/exam/exam';
import FileSaver from 'file-saver'
import { fetchlistGroupbyClassConfig } from '../../../http/student/student';
export interface Exam {
    createExam: Thunk<Exam, any>;
    fetchExamList: Thunk<Exam>;
    setExamist: Action<Exam, any>;
    examList: any;
    updateExam: Thunk<Exam, any>;
    deleteExam: Thunk<Exam, any>;

    ////////////////////////

    createSubject: Thunk<Exam, any>;
    fetchSubjectList: Thunk<Exam>;
    setSubjectList: Action<Exam, any>;
    subjectList: any;
    updateSubject: Thunk<Exam, any>;
    deleteSubject: Thunk<Exam, any>;

    ////////////////////////

    fetchShortCodeList: Thunk<Exam>;
    setShortCodelist: Action<Exam, any>;
    shortCodeTablelist: any;
    createShortCode: Thunk<Exam, any>;
    fetchShortCodeClassList: Thunk<Exam>;
    shortCodeClasslist: any;
    setShortCodeClasslist: Action<Exam, any>;
    updateShortCodeClasslist: Thunk<Exam, any>;
    deleteExamShortCode: Thunk<Exam, any>;

    ///////
    fetchGradeList: Thunk<Exam>;
    setGradelist: Action<Exam, any>;
    gradeTablelist: any;
    createExamGrade: Thunk<Exam, any>;
    updateExamGrade: Thunk<Exam, any>;

    //////
    fetchGroupList: Thunk<Exam>;
    setGrouplist: Action<Exam, any>;
    groupDropdownlist: any;
    fetchSubjectConfigurationList: Thunk<Exam>;
    fetchSubjectConfigurationListbyClassConfig: Thunk<Exam>;
    setSubjectConfigurationList: Action<Exam, any>;
    setSubjectConfigurationListByClass: Action<Exam>;
    subjectConfigurationList: any;
    setSubjectConfiguration: Thunk<Exam, any>;
    updateSubjectConfiguration: Thunk<Exam, any>;
    deleteSubjectConfiguration: Thunk<Exam, any>;

    ///////
    fetchExamfigurationList: Thunk<Exam>;
    setExamConfigureList: Action<Exam, any>;
    examConfigureList: any;
    createExamConfiguration: Thunk<Exam, any>;
    updateExamConfigurationMethod: Thunk<Exam, any>;

    ///
    fetchGroupByStudentClassList: Thunk<Exam>;
    setGroupListByStudentClass: Action<Exam, any>;
    subjectGroupListByStudentClass: any;
    fetchGroupListForMarkConfigSearch: Thunk<Exam>;
    subjectGroupListMarkConfigSearch: any;
    setSubjectGroupListMarkConfigSearch: Action<Exam, any>;

    ///
    fetchSubjectListByClassAndGroupId: Thunk<Exam>;
    setSubjectListByClassAndGroupId: Action<Exam, any>;
    subjectListByClassAndGroupId: any;

    ///
    fetchExamListByClassAndClassId: Thunk<Exam>;
    setExamListByClassAndClassId: Action<Exam, any>;
    examListByClassAndClassId: any;    
    fetchExamListByClassAndClassIdroutine: Thunk<Exam>;
    setExamListByClassAndClassIdroutine: Action<Exam, any>;
    examListByClassAndClassIdroutine: any;
    fetchExamListForMarkConfigSearch: Thunk<Exam>;
    setExamListForMarkConfigSearch: Action<Exam, any>;
    examListForMarkConfigSearch: any;

    fetchExamListByClassAndClassId2: Thunk<Exam>;
    setExamListByClassAndClassId2: Action<Exam, any>;
    examListByClassAndClassId2: any;

    fetchExamListByClassAndClassId3: Thunk<Exam>;
    setExamListByClassAndClassId3: Action<Exam, any>;
    examListByClassAndClassId3: any;

    fetchExamListByClassAndClassId4: Thunk<Exam>;
    setExamListByClassAndClassId4: Action<Exam, any>;
    examListByClassAndClassId4: any;

    fetchExamListByClassAndClassId5: Thunk<Exam>;
    setExamListByClassAndClassId5: Action<Exam, any>;
    examListByClassAndClassId5: any;

    ///
    fetchExamShortcodeListByClassId: Thunk<Exam>;
    setExamShortcodeListByClassId: Action<Exam, any>;
    examConfigurationListByClassId: any;
    markConfigureSave: Thunk<Exam, any>;
    fetchMarkConfigureList: Thunk<Exam>;
    setMarkConfigureList: Action<Exam, any>;
    markConfigureList: any;

    ///
    updateGrandFinalMarkConfig: Thunk<Exam, any>;

    ///
    fetchForthSubjectAssignList: Thunk<Exam>;
    setForthSubjectAssignList: Action<Exam, any>;
    forthSubjectAssignList: any;
    fetchForthSubjectChooseableList: Thunk<Exam>;
    fetchelectiveSubjectConfigurationListByClassConfigurationIdAndGroupId: Thunk<Exam>;
    setFetchForthSubjectChooseableList: Action<Exam, any>;
    setelectiveSubjectConfigurationListByClassConfigurationIdAndGroupId: Action<Exam, any>;
    forthSubjectChooseableList: any;
    electiveSubjectConfigurationListByClassConfigurationIdAndGroupId: any;
    assignForthSubjectChooseableList: Thunk<Exam, any>;

    ////
    fetchForthSubjectAssignedList: Thunk<Exam>;
    setForthSubjectAssignedList: Action<Exam, any>;
    forthSubjectAssignedList: any;
    deleteForthSubjectAssigned: Thunk<Exam, any>;

    ///
    fetchExamListForAdmitCardInstruction: Thunk<Exam>;
    setExamListForAdmitCardInstruction: Action<Exam, any>;
    examListForAdmitCardInstructionArray: any;
    saveExamInstruction: Thunk<Exam, any>;

    ///
    fetchMarkSheetList: Thunk<Exam>;
    setMarkSheetList: Action<Exam, any>;
    markSheetListArray: any;
    markSheetTemplateSave: Thunk<Exam, any>;

    ////
    remarkTemplateSave: Thunk<Exam, any>;
    fetchExamRemarksList: Thunk<Exam>;
    setExamRemarksList: Action<Exam, any>;
    examRemarksListArray: any;
    remarkTemplateUpdate: Thunk<Exam, any>;
    deleteRemarkTemplateDelete: Thunk<Exam, any>

    ///
    fetchSemesterListByClassConfigId: Thunk<Exam>;
    setSemesterListByClassConfigId: Action<Exam, any>;
    semesterListByClassConfigIdArray: any;

    ///
    fetchAdmitCardPdf: Thunk<Exam>;
    fetchSeatPlanPdf: Thunk<Exam>;

    ////
    fetchSubjectByGroupConfigId: Thunk<Exam>;
    setSubjectByGroupConfigId: Action<Exam, any>;
    subjectByGroupConfigIdArray: any;

    ////
    fetchExamMarkCofigureListByExamConfigId: Thunk<Exam>;
    setExamMarkCofigureListByExamConfigId: Action<Exam, any>;
    examMarkCofigureListByExamConfigId: any;    
    fetchExamMarkCofigureListByExamConfigId2: Thunk<Exam>;
    setExamMarkCofigureListByExamConfigId2: Action<Exam, any>;
    examMarkCofigureListByExamConfigId2: any;
    fetchExamMarkInputStudentList: Thunk<Exam>;
    fetchExamMarkInputStudentList2: Thunk<Exam>;
    setExamMarkInputStudentList: Action<Exam, any>;
    setExamMarkInputStudentList2: Action<Exam, any>;
    examMarkInputStudentList: any;
    examMarkInputStudentList2: any;
    examMarkInputSave: Thunk<Exam, any>;

    ////markUpdate

    fetchSemesterListByClassConfigIdMarkUpdate: Thunk<Exam>;
    setSemesterListByClassConfigIdMarkUpdate: Action<Exam, any>;
    semesterListByClassConfigIdArrayMarkUpdate: any;

    fetchlistGroupbyClassConfigMarkUpdate: Thunk<Exam>;
    setlistGroupbyClassConfigMarkUpdate: Action<Exam, any>;
    listGroupbyClassConfigMarkUpdate: any;

    fetchSubjectByGroupConfigIdMarkUpdate: Thunk<Exam>;
    setSubjectByGroupConfigIdMarkUpdate: Action<Exam, any>;
    subjectByGroupConfigIdArrayMarkUpdate: any;

    fetchExamMarkCofigureListByExamConfigIdMarkUpdate: Thunk<Exam>;
    setExamMarkCofigureListByExamConfigIdMarkUpdate: Action<Exam, any>;
    examMarkCofigureListByExamConfigIdMarkUpdate: any;

    fetchExamMarkInputStudentListMarkUpdate: Thunk<Exam>;
    setExamMarkInputStudentListMarkUpdate: Action<Exam, any>;
    examMarkInputStudentListMarkUpdate: any;

    //Mark delete
    fetchSemesterListByClassConfigIdMarkDelete: Thunk<Exam>;
    setSemesterListByClassConfigIdMarkDelete: Action<Exam, any>;
    semesterListByClassConfigIdArrayMarkDelete: any;

    fetchlistGroupbyClassConfigMarkDelete: Thunk<Exam>;
    setlistGroupbyClassConfigMarkDelete: Action<Exam, any>;
    listGroupbyClassConfigMarkDelete: any;

    fetchSubjectByGroupConfigIdMarkDelete: Thunk<Exam>;
    setSubjectByGroupConfigIdMarkDelete: Action<Exam, any>;
    subjectByGroupConfigIdArrayMarkDelete: any;

    fetchExamMarkCofigureListByExamConfigIdMarkDelete: Thunk<Exam>;
    setExamMarkCofigureListByExamConfigIdMarkDelete: Action<Exam, any>;
    examMarkCofigureListByExamConfigIdMarkDelete: any;

    fetchExamMarkStudentListMarkDelete: Thunk<Exam, any>;
    setExamMarkStudentListMarkDelete: Action<Exam, any>;
    examMarkStudentListMarkDelete: any;

    fetchExamMarkDelete: Thunk<Exam, any>;

    fetchMarkBlankSheetPdf: Thunk<Exam>;

    //general exam process
    fetchSemesterListByClassConfigIdForGeneralExamProcess: Thunk<Exam>;
    setSemesterListByClassConfigIdForGeneralExamProcess: Action<Exam, any>;
    semesterListByClassConfigIdForGeneralExamProcess: any;
    processgeneralExam: Thunk<Exam>;

    //general final exam result process
    fetchSemesterListByClassConfigIdForGeneralExamFinalProcess: Thunk<Exam>;
    setSemesterListByClassConfigIdForGeneralExamFinalProcess: Action<Exam, any>;
    semesterListByClassConfigIdForGeneralExamFinalProcess: any;
    processgeneralFinalExam: Thunk<Exam>;

    //merit position generate process
    fetchSemesterListByClassConfigIdForGeneralExamPositionGenerate: Thunk<Exam>;
    setSemesterListByClassConfigIdForGeneralExamPositionGenerate: Action<Exam, any>;
    semesterListByClassConfigIdForGeneralExamPositionGenerate: any;
    positionGenerateFinalExam: Thunk<Exam>;


    //remarks template list

    fetchRemarksTenplateList: Thunk<Exam>;
    setRemarksTenplateList: Action<Exam, any>;
    remarksTemplateListArray: any;

    fetchSemesterListByClassConfigIdRemarks: Thunk<Exam>;
    setSemesterListByClassConfigIdRemarks: Action<Exam, any>;
    remarksExamListArray: any;

    fetchStudentListByExamConfigIdAndClassConfigId: Thunk<Exam>;
    setStudentListByExamConfigIdAndClassConfigId: Action<Exam, any>;
    studentListByExamConfigIdAndClassConfigId: any

    saveRemarks: Thunk<Exam, any>;

    //tabulation sheet
    fetchSemesterListByClassConfigIdForGeneralTabulationSheet: Thunk<Exam>;
    setSemesterListByClassConfigIdForGeneralTabulationSheet: Action<Exam, any>;
    semesterListByClassConfigIdForGeneralTabulationSheet: any;

    downloadTabulationSheet: Thunk<any>;

    //general mark sheet download
    fetchSemesterListByClassConfigIdForGeneralMarkSheet: Thunk<Exam>;
    setSemesterListByClassConfigIdForGeneralMarkSheet: Action<Exam, any>;
    semesterListByClassConfigIdForGeneralMarkSheet: any;

    downloadGeneralMarkSheet: Thunk<any>;

    //grand final sheet download
    downloadGrandFinalMarkSheet: Thunk<any>;

    //Unassigned subject mark
    fetchExamUnassignedSubjectExamList: Thunk<Exam>;
    setExamUnassignedSubjectExamList: Action<Exam, any>;
    examUnassignedSubjectExamList: any;

    fetchExamUnassignedSubjectMarkList: Thunk<Exam>;
    setExamUnassignedSubjectMarkList: Action<Exam, any>;
    examUnassignedSubjectMarkList: any;

    //Section Wise Result
    fetchExamListByclassConfigIdSectionWiseExam: Thunk<Exam>;
    setExamListByclassConfigIdSectionWiseExam: Action<Exam, any>;
    examListByclassConfigIdSectionWiseExam: any;

    fetchSectionResultByAcademicYearClassConfigIdExamConfigId: Thunk<Exam>;
    setSectionResultByAcademicYearClassConfigIdExamConfigId: Action<Exam, any>;
    sectionResultByAcademicYearClassConfigIdExamConfigId: any;

    fetchSectionResultByAcademicYearClassConfigIdExamConfigId2: Thunk<Exam>;
    setSectionResultByAcademicYearClassConfigIdExamConfigId2: Action<Exam, any>;
    sectionResultByAcademicYearClassConfigIdExamConfigId2: any;

    //Section Wise Result
    fetchExamListByclassConfigIdClassWiseMerit: Thunk<Exam>;
    setExamListByclassConfigIdClassWiseMerit: Action<Exam, any>;
    examListByclassConfigIdClassWiseMerit: any;

    fetchSectionWiseMeritByAcademicYearClassConfigIdExamConfigId: Thunk<Exam>;
    setsectionWiseMeritByAcademicYearClassConfigIdExamConfigId: Action<Exam, any>;
    sectionWiseMeritByAcademicYearClassConfigIdExamConfigId: any;

    fetchClassWiseMeritByAcademicYearClassConfigIdExamConfigId: Thunk<Exam>;
    setClassWiseMeritByAcademicYearClassConfigIdExamConfigId: Action<Exam, any>;
    classWiseMeritByAcademicYearClassConfigIdExamConfigId: any;

    //class failed

    fetchClassWiseFailedExamListByClassAndClassId: Thunk<Exam>;
    setClassWiseFailedExamListByClassAndClassId: Action<Exam, any>;
    classWiseFailedexamListByClassAndClassId: any;

    //class merit
    fetchclassWiseMeritexamListByClassAndClassId: Thunk<Exam>;
    setclassWiseMeritexamListByClassAndClassId: Action<Exam, any>;
    classWiseMeritexamListByClassAndClassId: any;


    fetchClassWiseClassFailedByExamConfigId: Thunk<Exam>;
    setClassWiseClassFailedByClassConfigIdExamConfigId: Action<Exam, any>;
    classWiseClassFailedByClassConfigIdExamConfigId: any;

    //section failed
    fetchSectionWiseFailedExamListByClassAndClassId: Thunk<Exam>;
    setSectionWiseFailedExamListByClassAndClassId: Action<Exam, any>;
    sectionWiseFailedexamListByClassAndClassId: any;

    fetchSectionWiseClassFailedByExamConfigId: Thunk<Exam>;
    setSectionWiseClassFailedByClassConfigIdExamConfigId: Action<Exam, any>;
    sectionWiseClassFailedByClassConfigIdExamConfigId: any;

    //Section wise grading summary
    fetchGradingSummaryExamList: Thunk<Exam>;
    setGradingSummaryExamList: Action<Exam, any>;
    examGradingSummaryExamList: any;

    fetchGradingSummaryByAcademicYearExamidStudentList: Thunk<Exam>;
    setGradingSummaryByAcademicYearExamidStudentList: Action<Exam, any>;
    gradingSummaryByAcademicYearExamidStudentList: any;

    //Section wise pass fail summary

    fetchPassFailSummaryExamList: Thunk<Exam>;
    setPassFailSummaryExamList: Action<Exam, any>;
    examPassFailSummaryExamList: any;

    fetchPassFailSummaryByAcademicYearExamidStudentList: Thunk<Exam>;
    setPassFailSummaryByAcademicYearExamidStudentList: Action<Exam, any>;
    passfailSummaryByAcademicYearExamidStudentList: any;

    downloadtabulationExcel: Thunk<Exam, any>;
    fetchtabulationData: Thunk<Exam, any>;
    settabulationData: Action<Exam, any>;
    tabulationData: any;

    resultPublishDateList: any;
    setresultPublishDateList: Action<Exam, any>;
    fetchresultPublishDateList: Thunk<Exam>
    saveResultPublishDate: Thunk<Exam, any>
    updateResultPublishDate: Thunk<Exam, any>
    deleteResultPublishDate: Thunk<Exam, any>

    //loader section
    loading: boolean;
    setLoading: Action<Exam, boolean>;


}

export const examStore: Exam = {
    examList: [],
    subjectList: [],
    shortCodeTablelist: [],
    shortCodeClasslist: [],
    gradeTablelist: [],
    groupDropdownlist: [],
    subjectConfigurationList: [],
    examConfigureList: [],
    subjectGroupListByStudentClass: [],
    subjectGroupListMarkConfigSearch: [],
    subjectListByClassAndGroupId: [],
    examListByClassAndClassId: [],
    examListByClassAndClassIdroutine: [],
    examListByClassAndClassId2: [],
    examListByClassAndClassId3: [],
    examListByClassAndClassId4: [],
    examListByClassAndClassId5: [],
    examConfigurationListByClassId: [],
    markConfigureList: [],
    examListForMarkConfigSearch: [],
    forthSubjectAssignList: [],
    forthSubjectChooseableList: [],
    electiveSubjectConfigurationListByClassConfigurationIdAndGroupId: [],
    forthSubjectAssignedList: [],
    examListForAdmitCardInstructionArray: [],
    markSheetListArray: [],
    examRemarksListArray: [],
    semesterListByClassConfigIdArray: [],
    subjectByGroupConfigIdArray: [],
    examMarkCofigureListByExamConfigId: [],
    examMarkCofigureListByExamConfigId2: [],
    examMarkInputStudentList: [],
    examMarkInputStudentList2: [],
    semesterListByClassConfigIdArrayMarkUpdate: [],
    listGroupbyClassConfigMarkUpdate: [],
    subjectByGroupConfigIdArrayMarkUpdate: [],
    examMarkInputStudentListMarkUpdate: [],
    examMarkCofigureListByExamConfigIdMarkUpdate: [],
    semesterListByClassConfigIdArrayMarkDelete: [],
    listGroupbyClassConfigMarkDelete: [],
    subjectByGroupConfigIdArrayMarkDelete: [],
    examMarkCofigureListByExamConfigIdMarkDelete: [],
    examMarkStudentListMarkDelete: [],
    semesterListByClassConfigIdForGeneralExamProcess: [],
    semesterListByClassConfigIdForGeneralExamFinalProcess: [],
    semesterListByClassConfigIdForGeneralExamPositionGenerate: [],
    remarksTemplateListArray: [],
    remarksExamListArray: [],
    studentListByExamConfigIdAndClassConfigId: [],
    semesterListByClassConfigIdForGeneralTabulationSheet: [],
    semesterListByClassConfigIdForGeneralMarkSheet: [],
    examUnassignedSubjectExamList: [],
    examUnassignedSubjectMarkList: [],
    examListByclassConfigIdSectionWiseExam: [],
    sectionResultByAcademicYearClassConfigIdExamConfigId: [],
    sectionResultByAcademicYearClassConfigIdExamConfigId2: [],
    examListByclassConfigIdClassWiseMerit: [],
    sectionWiseMeritByAcademicYearClassConfigIdExamConfigId: [],
    classWiseMeritByAcademicYearClassConfigIdExamConfigId: [],
    classWiseClassFailedByClassConfigIdExamConfigId: [],
    classWiseFailedexamListByClassAndClassId: [],
    classWiseMeritexamListByClassAndClassId: [],
    sectionWiseFailedexamListByClassAndClassId: [],
    sectionWiseClassFailedByClassConfigIdExamConfigId: [],
    examGradingSummaryExamList: [],
    gradingSummaryByAcademicYearExamidStudentList: [],
    examPassFailSummaryExamList: [],
    passfailSummaryByAcademicYearExamidStudentList: [],
    tabulationData: [],

    /////////////Exam Config Start//////////////////
    fetchExamList: thunk(async (actions) => {
        actions.setLoading(true);
        const response = await fetchExam();
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            actions.setExamist(body.item);
            console.log('examList', body.item);

        } else {
            const body = await response.json();
            notification.error({ message: body.message })
            actions.setLoading(false);
        }
    }),
    setExamist: action((state, payload) => {
        state.examList = payload;
    }),
    createExam: thunk(async (actions, payload) => {
        const response = await examCreate(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchExamList();
            } else {
                notification.error({ message: body.message })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),
    loading: false,
    setLoading: action((state, payload) => {
        state.loading = payload;
    }),

    updateExam: thunk(async (actions, payload) => {

        const response = await examUpdate(payload);
        if (response.status === 201) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchExamList();
            } else {
                notification.error({ message: body.message })
            }

        } else {
            const body = await response.json();
            notification.error({ message: body.statusText })
        }
    }),
    deleteExam: thunk(async (actions, payload) => {


        const response = await examDeleteUrl(payload);
        if (response.status === 200) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchExamList();
                console.log('payload === ', payload);
            } else {
                notification.error({ message: body.message })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.statusText })
        }
    }),
    /////////////Exam Config End//////////////////

    /////////////Subject Config Start//////////////////
    fetchSubjectList: thunk(async (actions) => {
        actions.setLoading(true);
        const response = await fetchSubject();
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            actions.setSubjectList(body.item);
            console.log(body.item);

        } else {
            const body = await response.json();
            notification.error({ message: body.message })
            actions.setLoading(false);
        }
    }),
    setSubjectList: action((state, payload) => {
        state.subjectList = payload;
    }),
    createSubject: thunk(async (actions, payload) => {
        const response = await subjectCreate(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchSubjectList();
            } else {
                notification.error({ message: body.message })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),

    updateSubject: thunk(async (actions, payload) => {

        const response = await subjectUpdate(payload);
        if (response.status === 201) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchSubjectList();
            } else {
                notification.error({ message: body.message })
            }

        } else {
            const body = await response.json();
            notification.error({ message: body.statusText })
        }
    }),
    deleteSubject: thunk(async (actions, payload) => {
        const response = await subjectDeleteUrl(payload);
        if (response.status === 200) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchSubjectList();
                console.log('payload === ', payload);
            } else {
                notification.error({ message: body.message })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.statusText })
        }
    }),
    /////////////Subject Config End/////////////////////

    /////////////Exam Short Code Start////////////////// 
    fetchShortCodeList: thunk(async (actions) => {
        actions.setLoading(true);
        const response = await fetchShortCode();
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            actions.setShortCodelist(body.item);
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
            actions.setLoading(false);
        }
    }),
    setShortCodelist: action((state, payload) => {
        state.shortCodeTablelist = payload;
    }),
    createShortCode: thunk(async (actions, payload) => {
        const response = await shortCodeCreate(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchShortCodeList();
            } else {
                notification.error({ message: body.message })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),

    updateShortCodeClasslist: thunk(async (actions, payload) => {

        const response = await shortCodeUpdate(payload);
        if (response.status === 201) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchShortCodeList();
            } else {
                notification.error({ message: body.message })
            }

        } else {
            const body = await response.json();
            // notification.error({ message: body.statusText })
            notification.error({ message: "Duplicate shortcode update" })
        }
    }),

    deleteExamShortCode: thunk(async (actions, payload) => {
        const response = await examShortCodeDeleteUrl(payload);
        if (response.status === 201) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })

                actions.fetchShortCodeList();
            } else {
                notification.error({ message: "Delete failed" })
            }
        } else {
            const body = await response.json();
            notification.error({ message: "It can't be deleted" })
        }
    }),

    fetchShortCodeClassList: thunk(async (actions) => {
        actions.setLoading(true);
        const response = await fetchShortCodeClassListUrl();
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            actions.setShortCodeClasslist(body.item);
            console.log('body.item', body.item);

        } else {
            const body = await response.json();
            notification.error({ message: body.message })
            actions.setLoading(false);
        }
    }),
    setShortCodeClasslist: action((state, payload) => {
        state.shortCodeClasslist = payload;
    }),

    /////////////Exam Short Code End//////////////////   

    //Exam Grade start
    fetchGradeList: thunk(async (actions) => {
        actions.setLoading(true);
        const response = await fetchGrade();
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            actions.setGradelist(body.item);


        } else {
            const body = await response.json();
            notification.error({ message: body.message })
            actions.setLoading(false);
        }
    }),

    setGradelist: action((state, payload) => {
        state.gradeTablelist = payload;
    }),

    createExamGrade: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await createExamGradeUrl(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchGradeList();

            } else {
                notification.error({ message: body.message })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
            actions.setLoading(false);
        }
    }),

    updateExamGrade: thunk(async (actions, payload) => {

        const response = await updateExamGradeUrl(payload);
        if (response.status === 201) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchShortCodeClassList();
            } else {
                notification.error({ message: body.message })
            }

        } else {
            const body = await response.json();
            notification.error({ message: body.statusText })
        }
    }),

    //Exam Grade end

    //Subject Configuration Start

    fetchGroupList: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await fetchGroupListUrl(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            actions.setGrouplist(body.item);
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
            actions.setLoading(false);
        }
    }),

    setGrouplist: action((state, payload) => {
        state.groupDropdownlist = payload;
    }),

    setSubjectConfiguration: thunk(async (actions, payload) => {
        const response = await subjectConfigurationCreate(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                // console.log('payload', payload);
                var postData: any = {
                    classId: payload.classId,
                    groupId: payload.groupId
                };
                actions.fetchSubjectConfigurationList(postData);
            } else {
                notification.error({ message: body.message })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),


    fetchSubjectConfigurationList: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await fetchSubjectListByGroupUrl(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            if (body.item?.length>0){
                actions.setSubjectConfigurationList(body.item);
            } else {
                actions.setSubjectConfigurationList([]);
                notification.warn({message:"No Data Found"})
            }
           
            // console.log('body.item', body.item);
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
            actions.setLoading(false);
        }
    }),
    fetchSubjectConfigurationListbyClassConfig: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await fetchSubjectListByGroupID(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            actions.setSubjectConfigurationList(body.item);
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
            actions.setLoading(false);
        }
    }),

    setSubjectConfigurationList: action((state, payload) => {
        state.subjectConfigurationList = payload;
    }),    
    setSubjectConfigurationListByClass: action((state, payload) => {
        state.subjectConfigurationList = [];
    }),

    updateSubjectConfiguration: thunk(async (actions, payload) => {
        console.log('subjectConfigurationListData', payload);
        const response = await subjectConfigurationUpdate(payload);
        if (response.status === 201) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
            } else {
                notification.error({ message: body.message })
            }

        } else {
            const body = await response.json();
            notification.error({ message: body.statusText })
        }
    }),

    deleteSubjectConfiguration: thunk(async (actions, payload) => {
        const response = await subjectConfigurationDelete(payload);
        if (response.status === 201) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
            } else {
                notification.error({ message: body.message })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.statusText })
        }
    }),

    //Subject Configuration End 

    //Exam Configuration End   
    fetchExamfigurationList: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await fetchExamConfigurationListUrl(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            actions.setExamConfigureList(body.item);
            console.log('body.item---', body.item);

        } else {
            const body = await response.json();
            notification.error({ message: body.message })
            actions.setLoading(false);
        }
    }),
    setExamConfigureList: action((state, payload) => {
        state.examConfigureList = payload;
    }),
    createExamConfiguration: thunk(async (actions, payload) => {
        const response = await fetchExamConfiguration(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchExamfigurationList();
            } else {
                notification.error({ message: body.message })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),
    updateExamConfigurationMethod: thunk(async (actions, payload) => {
        const response = await examConfigurationUpdate(payload);
        if (response.status === 201) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchExamfigurationList();
            } else {
                notification.error({ message: body.message })
            }

        } else {
            const body = await response.json();
            notification.error({ message: body.statusText })
        }
    }),
    //Exam Configuration End  

    //Mark Configuration

    fetchGroupByStudentClassList: thunk(async (actions, payload, searchType) => {
        const response = await fetchGroupListByStudentClassUrl(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            actions.setGroupListByStudentClass(body.item);

        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),
    fetchGroupListForMarkConfigSearch: thunk(async (actions, payload, searchType) => {
        actions.setLoading(true);
        const response = await fetchGroupListByStudentClassUrl(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            actions.setSubjectGroupListMarkConfigSearch(body.item);

        } else {
            const body = await response.json();
            notification.error({ message: body.message })
            actions.setLoading(false);
        }
    }),
    setGroupListByStudentClass: action((state, payload) => {
        state.subjectGroupListByStudentClass = payload;
    }),
    setSubjectGroupListMarkConfigSearch: action((state, payload) => {
        state.subjectGroupListMarkConfigSearch = payload;
    }),

    fetchSubjectListByClassAndGroupId: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await fetchSubjectListByGroupIdNadClassIdListUrl(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            actions.setSubjectListByClassAndGroupId(body.item);

        } else {
            const body = await response.json();
            notification.error({ message: body.message })
            actions.setLoading(false);
        }
    }),
    setSubjectListByClassAndGroupId: action((state, payload) => {
        state.subjectListByClassAndGroupId = payload;
    }),

    fetchExamListByClassAndClassId: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await fetchExamByClassListUrl(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            actions.setExamListByClassAndClassId(body.item);

        } else {
            const body = await response.json();
            notification.error({ message: body.message })
            actions.setLoading(false);
        }
    }),    
    
    fetchExamListByClassAndClassIdroutine: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await fetchExamListByStudentClassUrl(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            actions.setExamListByClassAndClassIdroutine(body.item);

        } else {
            const body = await response.json();
            notification.error({ message: body.message })
            actions.setLoading(false);
            actions.setExamListByClassAndClassIdroutine([]);
        }
    }),

    fetchExamListByClassAndClassId2: thunk(async (actions, payload) => {
        const response = await fetchExamByClassList(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            actions.setExamListByClassAndClassId2(body.item);

        } else {
            const body = await response.json();
            notification.error({ message: body.message })
            actions.setLoading(false);
        }
    }),
    fetchExamListByClassAndClassId3: thunk(async (actions, payload) => {
        const response = await fetchExamByClassList(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            actions.setExamListByClassAndClassId3(body.item);

        } else {
            const body = await response.json();
            notification.error({ message: body.message })
            actions.setLoading(false);
        }
    }),

    fetchExamListByClassAndClassId4: thunk(async (actions, payload) => {
        const response = await fetchExamByClassList(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            actions.setExamListByClassAndClassId4(body.item);

        } else {
            const body = await response.json();
            notification.error({ message: body.message })
            actions.setLoading(false);
        }
    }),

    fetchExamListByClassAndClassId5: thunk(async (actions, payload) => {
        const response = await fetchExamByClassList(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            actions.setExamListByClassAndClassId5(body.item);

        } else {
            const body = await response.json();
            notification.error({ message: body.message })
            actions.setLoading(false);
        }
    }),
    fetchExamListForMarkConfigSearch: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await fetchExamByClassList(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            actions.setExamListForMarkConfigSearch(body.item);

        } else {
            const body = await response.json();
            notification.error({ message: body.message })
            actions.setLoading(false);
        }
    }),
    setExamListByClassAndClassId: action((state, payload) => {
        state.examListByClassAndClassId = payload;
    }),    
    setExamListByClassAndClassIdroutine: action((state, payload) => {
        state.examListByClassAndClassIdroutine = payload;
    }),

    setExamListByClassAndClassId2: action((state, payload) => {
        state.examListByClassAndClassId2 = payload;
    }),

    setExamListByClassAndClassId3: action((state, payload) => {
        state.examListByClassAndClassId3 = payload;
    }),

    setExamListByClassAndClassId4: action((state, payload) => {
        state.examListByClassAndClassId4 = payload;
    }),
    setExamListByClassAndClassId5: action((state, payload) => {
        state.examListByClassAndClassId5 = payload;
    }),
    setExamListForMarkConfigSearch: action((state, payload) => {
        state.examListForMarkConfigSearch = payload;
    }),

    fetchExamShortcodeListByClassId: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await fetchExamShortcodeByClassListUrl(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            actions.setExamShortcodeListByClassId(body.item);

        } else {
            const body = await response.json();
            notification.error({ message: body.message })
            actions.setLoading(false);
        }
    }),
    setExamShortcodeListByClassId: action((state, payload) => {
        state.examConfigurationListByClassId = payload;
    }),

    markConfigureSave: thunk(async (actions, payload) => {
        const response = await markConfigurationSave(payload);
        if (response.status === 201) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchExamfigurationList();
                actions.setSubjectListByClassAndGroupId([]);
                actions.setExamListByClassAndClassId5([]);
                actions.setExamShortcodeListByClassId([]);
            } else {
                notification.error({ message: body.message })
            }

        } else {
            const body = await response.json();
            notification.error({ message: "Duplicate entry" })
        }
    }),

    fetchMarkConfigureList: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await fetchMarkConfigListUrl(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            actions.setMarkConfigureList(body.item);
            console.log('body.item', body.item);

        } else {
            const body = await response.json();
            notification.error({ message: body.message })
            actions.setLoading(false);
        }
    }),

    setMarkConfigureList: action((state, payload) => {
        state.markConfigureList = payload;
    }),

    updateGrandFinalMarkConfig: thunk(async (actions, payload) => {
        const response = await grandFinalMarkConfig(payload);
        if (response.status === 201) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
            } else {
                notification.error({ message: body.message })
            }

        } else {
            const body = await response.json();
            notification.error({ message: body.statusText })
        }
    }),

    fetchForthSubjectAssignList: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await examForthSubjectConfigurationList(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            if (body.item?.length > 0) {
                actions.setForthSubjectAssignList(body.item);
            } else {
                notification.error({ message: "No data found" })
            }

        } else {
            const body = await response.json();
            notification.error({ message: body.message })
            actions.setLoading(false);
        }
    }),
    setForthSubjectAssignList: action((state, payload) => {
        state.forthSubjectAssignList = payload;
    }),

    fetchForthSubjectChooseableList: thunk(async (actions, payload) => {
        const response = await examForthSubjectChooseableList(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            actions.setFetchForthSubjectChooseableList(body.item);
            console.log('body.item', body.item);

        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),
    setFetchForthSubjectChooseableList: action((state, payload) => {
        state.forthSubjectChooseableList = payload;
    }),

    fetchelectiveSubjectConfigurationListByClassConfigurationIdAndGroupId: thunk(async (actions, payload) => {
        const response = await fetchelectiveSubjectConfigurationListByClassConfigurationIdAndGroupId(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            actions.setelectiveSubjectConfigurationListByClassConfigurationIdAndGroupId(body.item);
            console.log('body.item', body.item);

        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),
    setelectiveSubjectConfigurationListByClassConfigurationIdAndGroupId: action((state, payload) => {
        state.electiveSubjectConfigurationListByClassConfigurationIdAndGroupId = payload;
    }),

    assignForthSubjectChooseableList: thunk(async (actions, payload) => {
        const response = await assignForthSubject(payload);
        if (response.status === 201) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
            } else {
                notification.error({ message: body.message })
            }

        } else {
            const body = await response.json();
            notification.error({ message: body.statusText })
        }
    }),

    fetchForthSubjectAssignedList: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await fetchAssignForthSubjectList(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            actions.setForthSubjectAssignedList(body.item);

        } else {
            const body = await response.json();
            notification.error({ message: body.message })
            actions.setLoading(false);
        }
    }),

    setForthSubjectAssignedList: action((state, payload) => {
        state.forthSubjectAssignedList = payload;
    }),

    deleteForthSubjectAssigned: thunk(async (actions, payload) => {
        const response = await forthSubjectDelete(payload.studentSelected);
        if (response.status === 201) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchForthSubjectAssignedList(payload.section)
            } else {
                notification.error({ message: body.message })
            }

        } else {
            const body = await response.json();
            notification.error({ message: body.statusText })
        }
    }),

    fetchExamListForAdmitCardInstruction: thunk(async (actions, payload) => {
        const response = await examListForAdmitCardInstructionUrl(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            actions.setExamListForAdmitCardInstruction(body.item);
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),
    setExamListForAdmitCardInstruction: action((state, payload) => {
        state.examListForAdmitCardInstructionArray = payload;
    }),
    saveExamInstruction: thunk(async (actions, payload) => {
        const response = await examListForAdmitCardInstructionSaveUrl(payload);
        if (response.status === 201) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
            } else {
                notification.error({ message: body.message })
            }

        } else {
            const body = await response.json();
            notification.error({ message: body.statusText })
        }
    }),
    markSheetTemplateSave: thunk(async (actions, payload) => {
        const response = await fetchMarkSheetTemplateSaveUrl(payload);
        if (response.status === 201) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchMarkSheetList();
            } else {
                notification.error({ message: body.message })
            }

        } else {
            const body = await response.json();
            notification.error({ message: body.statusText })
        }
    }),
    fetchMarkSheetList: thunk(async (actions, payload) => {
        const response = await fetchMarkSheetTemplateUrl(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            actions.setMarkSheetList(body.item);
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),
    setMarkSheetList: action((state, payload) => {
        state.markSheetListArray = payload;
    }),
    remarkTemplateSave: thunk(async (actions, payload) => {
        // console.log('payload', payload);
        const response = await remarksSaveUrl(payload);
        if (response.status === 201) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchExamRemarksList();
            } else {
                notification.error({ message: body.message })
            }

        } else {
            const body = await response.json();
            notification.error({ message: body.statusText })
        }
    }),
    fetchExamRemarksList: thunk(async (actions, payload) => {
        const response = await remarksListUrl(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            actions.setExamRemarksList(body.item);
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),
    setExamRemarksList: action((state, payload) => {
        state.examRemarksListArray = payload;
    }),
    remarkTemplateUpdate: thunk(async (actions, payload) => {
        const response = await remarksLisUpdatetUrl(payload);
        if (response.status === 201) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchExamRemarksList()
            } else {
                notification.error({ message: body.message })
            }

        } else {
            const body = await response.json();
            notification.error({ message: body.statusText })
        }
    }),

    deleteRemarkTemplateDelete: thunk(async (actions, payload) => {
        const response = await remarksLisDeleteUrl(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchExamRemarksList()
            } else {
                notification.error({ message: body.message })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.statusText })
        }
    }),
    fetchSemesterListByClassConfigId: thunk(async (actions, payload) => {
        const response = await fetchSemesterListByClassConfigIdUrl(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            actions.setSemesterListByClassConfigId(body.item);
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),
    setSemesterListByClassConfigId: action((state, payload) => {
        state.semesterListByClassConfigIdArray = payload;
    }),

    fetchAdmitCardPdf: thunk(async (actions, payload) => {
        const response = await fetchAdmitCardDownloadUrl(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.blob();
            var blob = new Blob([body], { type: "application/octet-stream" });
            var fileName = "ADMIT_CARD.pdf";
            FileSaver.saveAs(blob, fileName);
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),    
    downloadtabulationExcel: thunk(async (actions, payload) => {
        const response = await downloadtabulationExcel(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.blob();
            var blob = new Blob([body], { type: "application/octet-stream" });
            var fileName = "TABULATION_SHEET.pdf";
            FileSaver.saveAs(blob, fileName);
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),
    fetchSeatPlanPdf: thunk(async (actions, payload) => {
        const response = await fetchSeatPLanDownloadUrl(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.blob();
            var blob = new Blob([body], { type: "application/octet-stream" });
            var fileName = "SEAT_PLAN.pdf";
            FileSaver.saveAs(blob, fileName);
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),

    fetchSubjectByGroupConfigId: thunk(async (actions, payload) => {
        const response = await fetchSubjectListByGroupID(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            actions.setSubjectByGroupConfigId(body.item);
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),

    setSubjectByGroupConfigId: action((state, payload) => {
        state.subjectByGroupConfigIdArray = payload;
    }),
    fetchExamMarkCofigureListByExamConfigId: thunk(async (actions, payload) => {
        const response = await fetchMarkConfigListbySubjectIdUrl(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            actions.setExamMarkCofigureListByExamConfigId(body.item);
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
            actions.setLoading(false);
        }
    }),    
    fetchExamMarkCofigureListByExamConfigId2: thunk(async (actions, payload) => {
        const response = await fetchMarkConfigListbySubjectIdUrl(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            actions.setExamMarkCofigureListByExamConfigId2(body.item);
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
            actions.setLoading(false);
        }
    }),
    setExamMarkCofigureListByExamConfigId: action((state, payload) => {
        state.examMarkCofigureListByExamConfigId = payload;
    }),   
     setExamMarkCofigureListByExamConfigId2: action((state, payload) => {
        state.examMarkCofigureListByExamConfigId2 = payload;
    }),
    fetchExamMarkInputStudentList: thunk(async (actions, payload) => {

        console.log('payload 2', payload);
        actions.setLoading(true);
        const response = await fetchExamMarkInputStudentListClassConfigExamConfigIdGroupIdSubjectId(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            if (body.item !== null) {
                actions.setExamMarkInputStudentList(body.item);
            } else {
                let emptyObject = {
                    shortCodeVisibilty: {},
                    studentList: []
                }
                actions.setExamMarkInputStudentList(emptyObject);
                notification.error({ message: "No Data Found" })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
            actions.setLoading(false);
        }
    }),    
    fetchExamMarkInputStudentList2: thunk(async (actions, payload) => {

        actions.setLoading(true);
        const response = await fetchExamMarkInputStudentListClassConfigExamConfigIdGroupIdSubjectId(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            if (body.item !== null) {
                actions.setExamMarkInputStudentList2(body.item);
            } else {
                let emptyObject = {
                    shortCodeVisibilty: {},
                    studentList: []
                }
                actions.setExamMarkInputStudentList2(emptyObject);
                notification.error({ message: "No Data Found" })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
            actions.setLoading(false);
        }
    }),
    setExamMarkInputStudentList: action((state, payload) => {
        state.examMarkInputStudentList = payload;
    }),    
    setExamMarkInputStudentList2: action((state, payload) => {
        state.examMarkInputStudentList2 = payload;
    }),
    examMarkInputSave: thunk(async (actions, payload) => {
        const response = await examMarkinputDataSaveUrl(payload);
        if (response.status === 201) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message })
                actions.fetchExamRemarksList()
            } else {
                notification.error({ message: body.message })
            }

        } else {
            const body = await response.json();
            notification.error({ message: body.statusText })
        }
    }),

    ///// Mark Update/////
    fetchSemesterListByClassConfigIdMarkUpdate: thunk(async (actions, payload) => {
        const response = await fetchSemesterListByClassConfigIdUrl(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            actions.setSemesterListByClassConfigIdMarkUpdate(body.item);
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),
    setSemesterListByClassConfigIdMarkUpdate: action((state, payload) => {
        state.semesterListByClassConfigIdArrayMarkUpdate = payload;
    }),
    fetchlistGroupbyClassConfigMarkUpdate: thunk(async (actions, payload) => {
        const response = await fetchlistGroupbyClassConfig(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();

            actions.setlistGroupbyClassConfigMarkUpdate(body?.item);
        } else {

        }
    }),
    setlistGroupbyClassConfigMarkUpdate: action((state, payload) => {
        state.listGroupbyClassConfigMarkUpdate = payload;
    }),
    fetchSubjectByGroupConfigIdMarkUpdate: thunk(async (actions, payload) => {
        const response = await fetchSubjectListByGroupID(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            actions.setSubjectByGroupConfigIdMarkUpdate(body.item);
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),
    setSubjectByGroupConfigIdMarkUpdate: action((state, payload) => {
        state.subjectByGroupConfigIdArrayMarkUpdate = payload;
    }),

    fetchExamMarkCofigureListByExamConfigIdMarkUpdate: thunk(async (actions, payload) => {
        const response = await fetchMarkConfigListbySubjectIdUrl(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            actions.setExamMarkCofigureListByExamConfigIdMarkUpdate(body.item);
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),
    setExamMarkCofigureListByExamConfigIdMarkUpdate: action((state, payload) => {
        state.examMarkCofigureListByExamConfigIdMarkUpdate = payload;
    }),

    fetchExamMarkInputStudentListMarkUpdate: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await fetchExamMarkInputStudentListClassConfigExamConfigIdGroupIdSubjectIdUpdateUrl(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            if (body.item !== null) {
                actions.setExamMarkInputStudentListMarkUpdate(body.item);
            } else {
                let emptyObject = {
                    shortCodeVisibilty: {},
                    studentList: []
                }
                actions.setExamMarkInputStudentListMarkUpdate(emptyObject);
                notification.error({ message: body.message })
            }

        } else {
            const body = await response.json();
            notification.error({ message: body.message })
            actions.setLoading(false);
        }
    }),
    setExamMarkInputStudentListMarkUpdate: action((state, payload) => {
        state.examMarkInputStudentListMarkUpdate = payload;
    }),

    fetchMarkBlankSheetPdf: thunk(async (actions, payload) => {
        const response = await markBlankSheeturl(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.blob();
            var blob = new Blob([body], { type: "application/octet-stream" });
            var fileName = "SEAT_PLAN.pdf";
            FileSaver.saveAs(blob, fileName);
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),

    ///////Mark Delete
    fetchSemesterListByClassConfigIdMarkDelete: thunk(async (actions, payload) => {
        const response = await fetchSemesterListByClassConfigIdUrl(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            actions.setSemesterListByClassConfigIdMarkDelete(body.item);
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),

    setSemesterListByClassConfigIdMarkDelete: action((state, payload) => {
        state.semesterListByClassConfigIdArrayMarkDelete = payload;
    }),

    fetchlistGroupbyClassConfigMarkDelete: thunk(async (actions, payload) => {
        const response = await fetchlistGroupbyClassConfig(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            actions.setlistGroupbyClassConfigMarkDelete(body?.item);
        } else {

        }
    }),

    setlistGroupbyClassConfigMarkDelete: action((state, payload) => {
        state.listGroupbyClassConfigMarkDelete = payload;
    }),

    fetchSubjectByGroupConfigIdMarkDelete: thunk(async (actions, payload) => {
        const response = await fetchSubjectListByGroupID(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            actions.setSubjectByGroupConfigIdMarkDelete(body.item);
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),

    setSubjectByGroupConfigIdMarkDelete: action((state, payload) => {
        state.subjectByGroupConfigIdArrayMarkDelete = payload;
    }),

    fetchExamMarkCofigureListByExamConfigIdMarkDelete: thunk(async (actions, payload) => {
        const response = await fetchMarkConfigListbySubjectIdUrl(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            actions.setExamMarkCofigureListByExamConfigIdMarkDelete(body.item);
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),



    setExamMarkCofigureListByExamConfigIdMarkDelete: action((state, payload) => {
        state.examMarkCofigureListByExamConfigIdMarkDelete = payload;
    }),

    fetchExamMarkStudentListMarkDelete: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await fetchExamMarkInputStudentListClassConfigExamConfigIdGroupIdSubjectIdUpdateUrl(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            if (body.item !== null) {
                actions.setExamMarkStudentListMarkDelete(body.item);
            } else {
                let emptyObject = {
                    shortCodeVisibilty: {},
                    studentList: []
                }
                actions.setExamMarkStudentListMarkDelete(emptyObject);
                notification.error({ message: "No Student Mark List for Delete" })
            }

        } else {
            const body = await response.json();
            notification.error({ message: body.message })
            actions.setLoading(false);
        }
    }),

    setExamMarkStudentListMarkDelete: action((state, payload) => {
        state.examMarkStudentListMarkDelete = payload;
    }),

    //markDelete
    fetchExamMarkDelete: thunk(async (actions, payload) => {
        const response = await examMarkinputDataDeleteUrl(payload.deleteIds);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            notification.success({ message: body.message });
            actions.fetchExamMarkStudentListMarkDelete(payload.markSaveObject)
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),

    //mark general exam process
    fetchSemesterListByClassConfigIdForGeneralExamProcess: thunk(async (actions, payload) => {
        const response = await fetchSemesterListByClassConfigIdUrl(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            actions.setSemesterListByClassConfigIdForGeneralExamProcess(body.item);
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),

    setSemesterListByClassConfigIdForGeneralExamProcess: action((state, payload) => {
        state.semesterListByClassConfigIdForGeneralExamProcess = payload;
    }),

    processgeneralExam: thunk(async (actions, payload) => {
        const response = await processExamResultGenerateUrl(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            notification.success({ message: body.message });
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),

    fetchSemesterListByClassConfigIdForGeneralExamFinalProcess: thunk(async (actions, payload) => {
        const response = await fetchSemesterListByClassConfigIdUrl(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            actions.setSemesterListByClassConfigIdForGeneralExamFinalProcess(body.item);
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),

    setSemesterListByClassConfigIdForGeneralExamFinalProcess: action((state, payload) => {
        state.semesterListByClassConfigIdForGeneralExamFinalProcess = payload;
    }),

    processgeneralFinalExam: thunk(async (actions, payload) => {
        const response = await processExamResultGrandFinalUrl(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body.messageType == 1) {
                notification.success({ message: body.message });
            } else {
                notification.error({ message: body.message });
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),

    fetchSemesterListByClassConfigIdForGeneralExamPositionGenerate: thunk(async (actions, payload) => {
        const response = await fetchSemesterListByClassConfigIdUrl(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body.messageType == 1) {
                actions.setSemesterListByClassConfigIdForGeneralExamPositionGenerate(body.item);
            } else {
                notification.error({ message: body.message });
            }

        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),

    setSemesterListByClassConfigIdForGeneralExamPositionGenerate: action((state, payload) => {
        state.semesterListByClassConfigIdForGeneralExamPositionGenerate = payload;
    }),

    positionGenerateFinalExam: thunk(async (actions, payload) => {
        const response = await processExamMaritPositionUrl(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            notification.success({ message: body.message });
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),

    //Remarks list

    fetchRemarksTenplateList: thunk(async (actions, payload) => {
        const response = await remarkTemplateList(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            actions.setRemarksTenplateList(body.item);
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),
    setRemarksTenplateList: action((state, payload) => {
        state.remarksTemplateListArray = payload;
    }),

    fetchSemesterListByClassConfigIdRemarks: thunk(async (actions, payload) => {
        const response = await fetchSemesterListByClassConfigIdRemarks(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            actions.setSemesterListByClassConfigIdRemarks(body.item);
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),

    setSemesterListByClassConfigIdRemarks: action((state, payload) => {
        state.remarksExamListArray = payload;
    }),

    fetchStudentListByExamConfigIdAndClassConfigId: thunk(async (actions, payload) => {
        const response = await fetchStudentListByExamConfigIdAndClassConfigIdUrl(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            actions.setStudentListByExamConfigIdAndClassConfigId(body.item);
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),
    setStudentListByExamConfigIdAndClassConfigId: action((state, payload) => {
        state.studentListByExamConfigIdAndClassConfigId = payload;
    }),

    saveRemarks: thunk(async (actions, payload) => {
        const response = await saveRemarksUrl(payload?.saveData);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            actions.fetchStudentListByExamConfigIdAndClassConfigId(payload?.searchData)
            notification.success({ message: body.message })
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),

    fetchSemesterListByClassConfigIdForGeneralTabulationSheet: thunk(async (actions, payload) => {
        const response = await fetchSemesterListByClassConfigIdUrl(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            actions.setSemesterListByClassConfigIdForGeneralTabulationSheet(body.item);
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),
    setSemesterListByClassConfigIdForGeneralTabulationSheet: action((state, payload) => {
        state.semesterListByClassConfigIdForGeneralTabulationSheet = payload;
    }),
    downloadTabulationSheet: thunk(async (actions, payload) => {
        const response = await tabulationSheetUrl(payload);
        // console.log(response);

        if (response.status === 201 || response.status === 200) {
            const body = await response.blob();
            var blob = new Blob([body], { type: "application/octet-stream" });
            var fileName = "TABULATION_SHEET.pdf";
            FileSaver.saveAs(blob, fileName);
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),

    fetchSemesterListByClassConfigIdForGeneralMarkSheet: thunk(async (actions, payload) => {
        const response = await fetchSemesterListByClassConfigIdUrl(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            actions.setSemesterListByClassConfigIdForGeneralMarkSheet(body.item);
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),

    setSemesterListByClassConfigIdForGeneralMarkSheet: action((state, payload) => {
        state.semesterListByClassConfigIdForGeneralMarkSheet = payload;
    }),

    downloadGeneralMarkSheet: thunk(async (actions, payload) => {
        const response = await generalMarkSheetDownloadUrl(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.blob();
            var blob = new Blob([body], { type: "application/octet-stream" });
            var fileName = "GENERAL_EXAM_MARK_SHEET.pdf";
            FileSaver.saveAs(blob, fileName);
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),


    //grand final mark sheet
    downloadGrandFinalMarkSheet: thunk(async (actions, payload) => {
        const response = await grandFinalMarkSheetDownloadUrl(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.blob();
            var blob = new Blob([body], { type: "application/octet-stream" });
            var fileName = "GENERAL_EXAM_MARK_SHEET.pdf";
            FileSaver.saveAs(blob, fileName);
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),

    fetchExamUnassignedSubjectExamList: thunk(async (actions) => {
        const response = await fetchExam();
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            actions.setExamUnassignedSubjectExamList(body.item);
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),

    setExamUnassignedSubjectExamList: action((state, payload) => {
        state.examUnassignedSubjectExamList = payload;
    }),

    fetchExamUnassignedSubjectMarkList: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await sectionWiseUnassignedMark(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            actions.setExamUnassignedSubjectMarkList(body.item);
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
            actions.setLoading(false);
        }
    }),

    setExamUnassignedSubjectMarkList: action((state, payload) => {
        state.examUnassignedSubjectMarkList = payload;
    }),

    fetchExamListByclassConfigIdSectionWiseExam: thunk(async (actions, payload) => {
        actions.setLoading(false);
        const response = await fetchSemesterListByClassConfigIdSectionWiseResult(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            actions.setExamListByclassConfigIdSectionWiseExam(body.item);
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
            actions.setLoading(false);
        }
    }),

    setExamListByclassConfigIdSectionWiseExam: action((state, payload) => {
        state.examListByclassConfigIdSectionWiseExam = payload;
    }),
    fetchSectionResultByAcademicYearClassConfigIdExamConfigId: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await fetchSubjectMarkListBySectionWiseResult(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            actions.setSectionResultByAcademicYearClassConfigIdExamConfigId(body.item);
            if (body?.item?.length === 0) {
                notification.warning({ message: "No Data Found" })
            }
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
            actions.setLoading(false);
        }
    }),
    setSectionResultByAcademicYearClassConfigIdExamConfigId: action((state, payload) => {
        state.sectionResultByAcademicYearClassConfigIdExamConfigId = payload;
    }),

    fetchSectionResultByAcademicYearClassConfigIdExamConfigId2: thunk(async (actions, payload) => {
        const response = await fetchSubjectMarkListBySectionWiseResult(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            actions.setSectionResultByAcademicYearClassConfigIdExamConfigId2(body.item);
            if (body?.item?.length === 0) {
                notification.warning({ message: "No Data Found" })
            }

        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),
    setSectionResultByAcademicYearClassConfigIdExamConfigId2: action((state, payload) => {
        state.sectionResultByAcademicYearClassConfigIdExamConfigId2 = payload;
    }),
    fetchExamListByclassConfigIdClassWiseMerit: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await fetchSemesterListByClassConfigIdSectionWiseResult(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            actions.setExamListByclassConfigIdClassWiseMerit(body.item);
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
            actions.setLoading(false);
        }
    }),
    setExamListByclassConfigIdClassWiseMerit: action((state, payload) => {
        state.examListByclassConfigIdClassWiseMerit = payload;
    }),

    fetchSectionWiseMeritByAcademicYearClassConfigIdExamConfigId: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await fetchsectionMerit(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            actions.setsectionWiseMeritByAcademicYearClassConfigIdExamConfigId(body.item);
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
            actions.setLoading(false);
        }
    }),
    setsectionWiseMeritByAcademicYearClassConfigIdExamConfigId: action((state, payload) => {
        state.sectionWiseMeritByAcademicYearClassConfigIdExamConfigId = payload;
    }),
    fetchClassWiseMeritByAcademicYearClassConfigIdExamConfigId: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await fetchClassWiseMeritByAcademicYearClassConfigIdExamConfigId(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            actions.setClassWiseMeritByAcademicYearClassConfigIdExamConfigId(body.item);
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
            actions.setLoading(false);
        }
    }),
    setClassWiseMeritByAcademicYearClassConfigIdExamConfigId: action((state, payload) => {
        state.classWiseMeritByAcademicYearClassConfigIdExamConfigId = payload;
    }),

    fetchClassWiseFailedExamListByClassAndClassId: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await fetchSemesterListByClassConfigIdSectionWiseResult(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            actions.setClassWiseFailedExamListByClassAndClassId(body.item);
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
            actions.setLoading(false);
        }
    }),

    setClassWiseFailedExamListByClassAndClassId: action((state, payload) => {
        state.classWiseFailedexamListByClassAndClassId = payload;
    }),

    fetchclassWiseMeritexamListByClassAndClassId: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await classWiseMeritExamUrl(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            actions.setclassWiseMeritexamListByClassAndClassId(body.item);
        } else {
            const body = await response.json();
            notification.error({ message: body.message });
            actions.setclassWiseMeritexamListByClassAndClassId(body.item);
            actions.setLoading(false);
        }
    }),

    setclassWiseMeritexamListByClassAndClassId: action((state, payload) => {
        state.classWiseMeritexamListByClassAndClassId = payload;
    }),

    fetchClassWiseClassFailedByExamConfigId: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await classWiseFailedExamUrl(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            actions.setClassWiseClassFailedByClassConfigIdExamConfigId(body.item);
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
            actions.setLoading(false);
        }
    }),
    setClassWiseClassFailedByClassConfigIdExamConfigId: action((state, payload) => {
        state.classWiseClassFailedByClassConfigIdExamConfigId = payload;
    }),

    fetchSectionWiseFailedExamListByClassAndClassId: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await fetchSemesterListByClassConfigIdSectionWiseResult(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            actions.setSectionWiseFailedExamListByClassAndClassId(body.item);
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
            actions.setLoading(false);
        }
    }),

    setSectionWiseFailedExamListByClassAndClassId: action((state, payload) => {
        state.sectionWiseFailedexamListByClassAndClassId = payload;
    }),

    fetchSectionWiseClassFailedByExamConfigId: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await sectionWiseFailedExamUrl(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            actions.setSectionWiseClassFailedByClassConfigIdExamConfigId(body.item);
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
            actions.setLoading(false);
        }
    }),

    setSectionWiseClassFailedByClassConfigIdExamConfigId: action((state, payload) => {
        state.sectionWiseClassFailedByClassConfigIdExamConfigId = payload;
    }),

    fetchGradingSummaryExamList: thunk(async (actions) => {
        actions.setLoading(true);
        const response = await fetchExam();
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            actions.setGradingSummaryExamList(body.item);
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
            actions.setLoading(false);
        }
    }),
    setGradingSummaryExamList: action((state, payload) => {
        state.examGradingSummaryExamList = payload;
    }),

    fetchGradingSummaryByAcademicYearExamidStudentList: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await sectionWiseGradingSummaryUrl(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            if (body.item !== null) {
                actions.setGradingSummaryByAcademicYearExamidStudentList(body.item);
            } else {
                actions.setGradingSummaryByAcademicYearExamidStudentList([]);
                actions.setLoading(false);
                notification.error({ message: 'No data found' })
            }
            // const body = await response.json();
            // actions.setGradingSummaryByAcademicYearExamidStudentList(body.item);            
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),

    setGradingSummaryByAcademicYearExamidStudentList: action((state, payload) => {
        state.gradingSummaryByAcademicYearExamidStudentList = payload;
    }),

    fetchPassFailSummaryExamList: thunk(async (actions) => {
        actions.setLoading(true);
        const response = await fetchExam();
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            actions.setPassFailSummaryExamList(body.item);
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
            actions.setLoading(false);
        }
    }),
    setPassFailSummaryExamList: action((state, payload) => {
        state.examPassFailSummaryExamList = payload;
    }),

    fetchPassFailSummaryByAcademicYearExamidStudentList: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await sectionWisePassFailSummaryUrl(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            if (body.item !== null) {
                actions.setPassFailSummaryByAcademicYearExamidStudentList(body.item);
            } else {
                actions.setPassFailSummaryByAcademicYearExamidStudentList([]);
                notification.error({ message: 'No data found' })
                actions.setLoading(false);
            }
            // const body = await response.json();
            // actions.setGradingSummaryByAcademicYearExamidStudentList(body.item);            
        } else {
            const body = await response.json();
            notification.error({ message: body.message })
        }
    }),
    setPassFailSummaryByAcademicYearExamidStudentList: action((state, payload) => {
        state.passfailSummaryByAcademicYearExamidStudentList = payload;
    }),

    fetchtabulationData: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await fetchtabulationData(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            if (body?.messageType === 1) {
                actions.settabulationData(body.item);
            } else {
                notification.error({ message: "No Data Found" });
                actions.settabulationData([]);
            }

        } else {
            notification.error({ message: "Something went wrong" })
            actions.setLoading(false);
        }
    }),
    settabulationData: action((state, payload) => {
        state.tabulationData = payload;
    }),

    ///Fee amount
    resultPublishDateList: [],
    fetchresultPublishDateList: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await fetchresultPublishDateList(payload);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            actions.setresultPublishDateList(body?.item);
        } else {
            actions.setLoading(false);
            actions.setresultPublishDateList([]);
        }
    }),

    setresultPublishDateList: action((state, payload) => {
        state.resultPublishDateList = payload;
    }),

    saveResultPublishDate: thunk(async (actions, payload) => {
        const response = await saveResultPublishDate(payload);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body?.messageType === 1) {
                notification.success({ message: body.message })
            }
            if (body?.messageType === 0) {
                notification.warn({ message: body.message })
            }
            //actions.fetchfeeAmountConfigurationList();
        } else {
            notification.error({ message: "Something went wrong" })
        }
    }),


    updateResultPublishDate: thunk(async (actions, payload) => {
        actions.setLoading(true);
        const response = await updateResultPublishDate(payload.data);
        if (response.status === 201 || response.status === 200) {
            actions.setLoading(false);
            const body = await response.json();
            if (body?.messageType === 1) {
                notification.success({ message: body.message });
                actions.fetchresultPublishDateList(payload.search);
            }
            if (body?.messageType === 0) {
                notification.warn({ message: body.message })
            }
        } else {
            notification.error({ message: "Something went wrong" })
            actions.setLoading(false);
        }
    }),

    deleteResultPublishDate: thunk(async (actions, payload) => {
        const response = await deleteResultPublishDate(payload.data);
        if (response.status === 201 || response.status === 200) {
            const body = await response.json();
            if (body?.messageType === 1) {
                notification.success({ message: body.message });
                actions.fetchresultPublishDateList(payload.search);
            }
            if (body?.messageType === 0) {
                notification.warn({ message: body.message })
            }
            // actions.fetchfeeAmountConfigurationList();
        } else {
            notification.error({ message: "Something went wrong" })
        }
    }),

    ///
}
